module.exports = __webpack_public_path__ + "assets/img/logo_lo_scalo.56b68dfb.png";